module.exports = __webpack_public_path__ + "static/media/tendon-dark.a5289a01.png";